/*
 * EditAccount Messages
 *
 * This contains all the text for the EditAccount component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.EditAccount.header',
    defaultMessage: 'Account',
  },
  details: {
    id: 'app.components.EditAccount.details',
    defaultMessage: 'Account Details',
  },
  name: {
    id: 'app.components.EditAccount.name',
    defaultMessage: 'Name',
  },
  language: {
    id: 'app.common.language',
    defaultMessage: 'Language',
  },
  username: {
    id: 'app.components.EditAccount.username',
    defaultMessage: 'Username',
  },
  pattern: {
    id: 'app.components.EditAccount.pattern',
    defaultMessage: "Use 6–100 characters without '@'",
  },
  email: {
    id: 'app.components.EditAccount.email',
    defaultMessage: 'Email',
  },
  password: {
    id: 'app.components.EditAccount.password',
    defaultMessage: 'Password',
  },
  changePassword: {
    id: 'app.components.EditAccount.changePassword',
    defaultMessage: 'Change password',
  },
  passwordChanged: {
    id: 'app.components.EditAccount.passwordChanged',
    defaultMessage: 'The password has been changed',
  },
  usernameConflict: {
    id: 'app.components.EditAccount.usernameConflict',
    defaultMessage: 'The username has been taken already',
  },
  altLoginHeader: {
    id: 'app.components.EditAccount.altLoginHeader',
    defaultMessage: 'Log in with Google, Microsoft, or Apple ID',
  },
  altLoginText: {
    id: 'app.components.EditAccount.altLoginText',
    defaultMessage: 'Don\'t want to always remember your Social Schools username and password? Then connect a Google account, Microsoft account or Apple ID, so you can log in to Social Schools using this account.',
  },
  connect: {
    id: 'app.components.EditAccount.connect',
    defaultMessage: 'Connect',
  },
  remove: {
    id: 'app.common.remove',
    defaultMessage: 'Remove',
  },
  removeConnection: {
    id: 'app.components.EditAccount.removeConnection',
    defaultMessage: 'Remove Connection',
  },
  removeConfirm: {
    id: 'app.components.EditAccount.removeConfirm',
    defaultMessage: 'Do you want to remove this <b>{label}</b> connection?',
  },
  deleteAccount: {
    id: 'app.components.EditAccount.deleteAccount',
    defaultMessage: 'Delete Account',
  },
  deleteAccountIntro: {
    id: 'app.components.EditAccount.deleteAccountIntro',
    defaultMessage: 'All your data will be deleted when you delete your account. In case you have multiple roles on this account, all of them will be deleted.',
  },
  deleteAccountModal1: {
    id: 'app.components.EditAccount.deleteAccountModal1',
    defaultMessage: 'Are you sure you want to delete the account registered with <b>{accountIdentifier}</b> and all its related data?{br}This action cannot be undone.',
  },
  deleteAccountModal2: {
    id: 'app.components.EditAccount.deleteAccountModal2',
    defaultMessage: "Once you press 'Confirm', your account will be removed and you will be logged out.",
  },
  confirm: {
    id: 'app.components.EditContactDetails.confirmButton',
    defaultMessage: 'Confirm',
  },
  delete: {
    id: 'app.components.EditAccount.delete',
    defaultMessage: 'delete',
  },
  translateMessages: {
    id: 'app.components.EditAccount.translateMessages',
    defaultMessage: 'Translate Messages',
  },
  dontTranslate: {
    id: 'app.components.EditAccount.dontTranslate',
    defaultMessage: "Don't translate",
  },
  translateIntro: {
    id: 'app.components.EditAccount.translateIntro',
    defaultMessage: 'Group messages are automatically translated into the chosen language.',
  },
  socsDisabled: {
    id: 'app.components.EditAccount.socsDisabled',
    defaultMessage: 'Your Social Schools username and password are disabled.{br}Re-enable them below to edit your username and password.',
  },
  logInSocs: {
    id: 'app.components.EditAccount.logInSocs',
    defaultMessage: 'Log in with Social Schools username and password',
  },
  logInSocsText: {
    id: 'app.components.EditAccount.logInSocsText',
    defaultMessage: 'If you have linked a Google account, Microsoft account or Apple ID, you can disable login with your Social Schools username and password.{br}This way you can improve the security of your account.',
  },

});
